<template id="login">
  <div class="container">
    <div class="container-member">
      <h1 class="page-title on-header">
        아이디/비밀번호 찾기
        <button type="button" class="btn-back"><i class="xi-arrow-left" /></button>
      </h1>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Find',
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {},
};

</script>
